const cityEvents = () => {
    const showAllButton = document.getElementById('event-show-all-btn');
    const eventItems = document.querySelectorAll('#event-list .hidden-item');

    let currentIndex = 0;

    const showNextEvents = () => {
        const itemsToShow = 3; // Number of items to show per click

        const promises = [];
        for (let i = 0; i < itemsToShow && currentIndex < eventItems.length; i++) {
            const item = eventItems[currentIndex];

            const img = item.querySelector('img');
            const promise = new Promise(resolve => {
                if (img && img.complete) {
                    resolve();
                } else if (img) {
                    img.onload = resolve;
                    img.onerror = resolve;
                } else {
                    resolve();
                }
            }).then(() => {
                showAllButton.setAttribute('aria-expanded', 'true');
                item.classList.remove('hidden');
                setTimeout(() => {
                    item.classList.remove('hidden-item');
                    item.classList.add('visible-item');
                }, i * 100) // Stagger -- can be removed --

            });

            promises.push(promise);
            currentIndex += 1;
        }

        Promise.all(promises).then(() => {
            if (currentIndex >= eventItems.length) {
                showAllButton.setAttribute('aria-hidden', 'true');
                showAllButton.setAttribute('disabled', true);
                showAllButton.style.display = 'none';
            }
        });
    };

    if (showAllButton) {
        showAllButton.addEventListener('click', () => {
            showNextEvents();
        });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    cityEvents();
});
